// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/contextMenu/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/contextMenu/desktop.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/contextMenu/flag.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/contextMenu/folder.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/contextMenu/send.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/contextMenu/message.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/contextMenu/tag.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/contextMenu/target.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subtitlesContextMenu_icon--edit::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.subtitlesContextMenu_icon--desktop::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.subtitlesContextMenu_icon--flag::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.subtitlesContextMenu_icon--folder::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.subtitlesContextMenu_icon--send::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.subtitlesContextMenu_icon--message::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.subtitlesContextMenu_icon--tag::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.subtitlesContextMenu_icon--target::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}`, "",{"version":3,"sources":["webpack://./src/components/subtitles/SubtitlesContextMenu.css"],"names":[],"mappings":"AAAA;IACI,yDAA0D;AAC9D;;AAEA;IACI,yDAA6D;AACjE;;AAEA;IACI,yDAA0D;AAC9D;;AAEA;IACI,yDAA4D;AAChE;;AAEA;IACI,yDAA0D;AAC9D;;AAEA;IACI,yDAA6D;AACjE;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,yDAA4D;AAChE","sourcesContent":[".subtitlesContextMenu_icon--edit::before{\n    background-image: url(\"../../assets/contextMenu/edit.svg\");\n}\n\n.subtitlesContextMenu_icon--desktop::before{\n    background-image: url(\"../../assets/contextMenu/desktop.svg\");\n}\n\n.subtitlesContextMenu_icon--flag::before{\n    background-image: url(\"../../assets/contextMenu/flag.svg\");\n}\n\n.subtitlesContextMenu_icon--folder::before{\n    background-image: url(\"../../assets/contextMenu/folder.svg\");\n}\n\n.subtitlesContextMenu_icon--send::before{\n    background-image: url(\"../../assets/contextMenu/send.svg\");\n}\n\n.subtitlesContextMenu_icon--message::before{\n    background-image: url(\"../../assets/contextMenu/message.svg\");\n}\n\n.subtitlesContextMenu_icon--tag::before{\n    background-image: url(\"../../assets/contextMenu/tag.svg\");\n}\n\n.subtitlesContextMenu_icon--target::before{\n    background-image: url(\"../../assets/contextMenu/target.svg\");\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
